import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-slider', {
    month: {
        0: 'mėnesių',
        1: 'mėnuo',
        2: 'mėnesiai',
    },
    year: {
        0: 'metų',
        1: 'metai',
        2: 'metai',
    },
    value: 'Vertė',
    minValue: 'Minimali vertė yra',
    maxValue: 'Maksimali vertė yra',
});
